<template>
  <div>
    <div class="header-section">
      <div class="content-section">
        <h3 class="section-title">
          {{ $t("loginSettings") }}
        </h3>
        <div class="content mb-5">
          <div class="grid grid-cols-2 gap-4">
            <div class="flex flex-col">
              <label class="text-sm mb-1">{{ $t('templateId') }}</label>
              <input
                v-model="settings.settings.template_id"
                type="number"
                class="input-main"
                dir="ltr"
              />
            </div>
            <div class="flex flex-col">
              <label class="text-sm mb-1">{{ $t('lineNumber') }} <span class="text-[10px]"> ( {{ $t('useForBulkSent') }} )</span> </label>
              <input
                v-model="settings.settings.line_number"
                type="number"
                class="input-main"
                dir="ltr"
              />
            </div>
          </div>
        </div>

      
        <div class="content mb-5 flex gap-4">
      

          <label
            class="switch peer"
            for="show_logo"
            ><input
              id="show_logo"
              value="True"
              v-model="
                settings.settings.show_logo
              "
              type="checkbox"
            />
            <div class="slider round"></div>
          </label>
          <div class="flex flex-col gap-1">
            <div class="text font-extralight">
              {{ $t("ShowLoginLogo") }}
            </div>
            <div
              class="sub-text text-xs font-extralight text-[#696767]"
            >
              {{ $t("ShowLoginLogoDescription") }}
            </div>
          </div>
        </div>

        <!-- Logo Upload Section - Only visible when show_logo is enabled -->
        <div v-if="settings.settings.show_logo" class="content mb-5 ml-12">
          <div class="flex flex-col gap-3">
            <div class="flex items-center gap-3">
              <div v-if="settings.settings.custom_logo_url" class="logo-preview bg-gray-100 rounded-lg p-3 border border-gray-200">
                <img :src="settings.settings.custom_logo_url" alt="Login Logo" class="h-16 object-contain" />
              </div>
              <div class="flex flex-col gap-2">
                <button 
                  @click="openMediaUploader" 
                  class="px-4 py-2 bg-[#F2F2F2] rounded-full hover:bg-gray-200 text-xs flex items-center gap-2"
                >
                  <i class="icon-smsir-write text-[20px]"></i>
                  {{ settings.settings.custom_logo_url ? $t('changeLogo') : $t('uploadLogo') }}
                </button>
                <button 
                  v-if="settings.settings.custom_logo_url" 
                  @click="removeLogo" 
                  class="px-4 py-2 bg-gray-100 rounded-full hover:bg-gray-200 text-xs text-red-500 flex items-center gap-2"
                >
                  <i class="icon-smsir-trash-bin-trash text-[18px]"></i>
                  {{ $t('removeLogo') }}
                </button>
              </div>
            </div>
        
          </div>
        </div>

        <div class="content mb-5 flex gap-4">
      

      <label
        class="switch peer"
        for="show_copyright"
        ><input
          id="show_copyright"
          value="True"
          v-model="
            settings.settings.show_copyright
          "
          type="checkbox"
        />
        <div class="slider round"></div>
      </label>
      <div class="flex flex-col gap-1">
        <div class="text font-extralight">
          {{ $t("ShowCopyRights") }}
        </div>
        <div
          class="sub-text text-xs font-extralight text-[#696767]"
        >
          {{ $t("ShowCopyRightsDescription") }}
        </div>
      </div>
    </div>
        <div class="content mb-5 flex gap-4">
          <label
            class="switch peer"
            for="change_admin"
            ><input
              id="change_admin"
              value="True"
              v-model="
                settings.settings.change_admin
              "
              type="checkbox"
            />
            <div class="slider round"></div>
          </label>
          <div class="flex flex-col gap-1">
            <div class="text font-extralight">
              {{ $t("ChangeAdminLogin") }}
            </div>
            <div
              class="sub-text text-xs font-extralight text-[#696767]"
            >
              {{ $t("ChangeAdminLoginDescription") }}
            </div>
          </div>
        </div>
        <div class="content mb-5 flex gap-4">
          <label
            class="switch peer"
            for="custom_redirect"
          >
            <input
              id="custom_redirect"
              value="True"
              v-model="
                settings.settings.custom_redirect
              "
              type="checkbox"
            />
            <div class="slider round"></div>
          </label>
          <div class="flex flex-col gap-1">
            <div class="text font-extralight">
              {{ $t("CustomRedirect") }}
            </div>
            <div
              class="sub-text text-xs font-extralight text-[#696767]"
            >
              {{
                $t("CustomRedirectDescription")
              }}
            </div>
          </div>
        </div>

      

        <div
          v-if="settings.settings.custom_redirect"
          class="content mb-5 flex flex-col gap-4 pr-12"
        >
          <div class="flex gap-4 items-center">
            <label class="w-64 text-sm"
              >{{ $t("FormRedirect") }}:</label
            >
            <input
              v-model="
                settings.settings
                  .form_redirect_url
              "
              class="input-main"
              dir="ltr"
              :placeholder="
                $t('EnterRedirectURL')
              "
              type="text"
            />
          </div>

          <div class="flex gap-4 items-center">
            <label class="w-64 text-sm"
              >{{ $t("ModalRedirect") }}:</label
            >
            <input
              v-model="
                settings.settings
                  .modal_redirect_url
              "
              class="input-main"
              dir="ltr"
              :placeholder="
                $t('EnterRedirectURL')
              "
              type="text"
            />
          </div>
        </div>
        <div class="content mb-5 flex gap-4">
          <label class="switch peer">
            <input
              v-model="
                settings.settings.require_email
              "
              type="checkbox"
            />
            <div class="slider round"></div>
          </label>
          <div class="flex flex-col">
            <div class="text font-extralight">
              {{ $t("requireEmail") }}
            </div>
            <div
              class="sub-text text-xs font-extralight text-[#696767]"
            >
              {{ $t("requireEmailDescription") }}
            </div>
          </div>
        </div>
        <div class="content mb-5 flex gap-4">
          <label class="switch peer">
            <input
              v-model="
                settings.settings
                  .require_first_name
              "
              type="checkbox"
            />
            <div class="slider round"></div>
          </label>
          <div class="flex flex-col">
            <div class="text font-extralight">
              {{ $t("requireFirstName") }}
            </div>
            <div
              class="sub-text text-xs font-extralight text-[#696767]"
            >
              {{
                $t("requireFirstNameDescription")
              }}
            </div>
          </div>
        </div>

        <div class="content mb-5 flex gap-4">
          <label class="switch peer">
            <input
              v-model="
                settings.settings
                  .require_last_name
              "
              type="checkbox"
            />
            <div class="slider round"></div>
          </label>
          <div class="flex flex-col">
            <div class="text font-extralight">
              {{ $t("requireLastName") }}
            </div>
            <div
              class="sub-text text-xs font-extralight text-[#696767]"
            >
              {{
                $t("requireLastNameDescription")
              }}
            </div>
          </div>
        </div>
        <div class="content mb-5">
          <h3 class="section-title mb-3">
            {{ $t("userRoleSettings") }}
          </h3>
          <div class="flex flex-col">
            <label class="text-sm mb-1">{{ $t('defaultUserRole') }}</label>
            <select
              v-model="settings.settings.default_user_role"
              class="input-main"
            >
              <option 
                v-for="role in availableRoles" 
                :key="role.value" 
                :value="role.value"
              >
                {{ role.label }}
              </option>
            </select>
            <div class="sub-text text-xs font-extralight text-[#696767] mt-1">
              {{ $t('defaultUserRoleDescription') }}
            </div>
          </div>
        </div>
        
        <div class="content mb-5">
          <h3 class="section-title">
            {{ $t("securitySettings") }}
          </h3>
          <div class="grid grid-cols-1 gap-4">
            <div class="flex items-center gap-4">
              <label class="switch peer">
                <input
                  v-model="
                    settings.settings
                      .rate_limit_active
                  "
                  type="checkbox"
                />
                <div class="slider round"></div>
              </label>
              <div class="flex flex-col">
                <div class="text font-extralight">
                  {{ $t("enableRateLimit") }}
                </div>
                <div
                  class="sub-text text-xs font-extralight text-[#696767]"
                >
                  {{ $t("rateLimitDescription") }}
                </div>
              </div>
            </div>

            <div
              v-if="
                settings.settings
                  .rate_limit_active
              "
              class="grid grid-cols-2 gap-4"
            >
              <div class="flex flex-col">
                <label class="text-sm mb-1">{{
                  $t("maxAttempts")
                }}</label>
                <input
                  v-model="
                    settings.settings.max_attempts
                  "
                  type="number"
                  class="input-main"
                  min="1"
                />
              </div>
              <div class="flex flex-col">
                <label class="text-sm mb-1"
                  >{{ $t("banDuration") }} ({{
                    $t("seconds")
                  }})</label
                >
                <input
                  v-model="
                    settings.settings.ban_duration
                  "
                  type="number"
                  class="input-main"
                  min="60"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="content mb-5">
          <h3 class="section-title">
            {{ $t("otpSettings") }}
          </h3>
          <div class="grid grid-cols-2 gap-4">
      

            <div class="flex flex-col">
              <label class="text-sm mb-1">{{
                $t("otpLength")
              }}</label>
              <input
                v-model="
                  settings.settings.otp_length
                "
                type="number"
                class="input-main"
                min="4"
                max="8"
              />
            </div>
            <div class="flex flex-col">
              <label class="text-sm mb-1"
                >{{ $t("otpExpiry") }} ({{
                  $t("seconds")
                }})</label
              >
              <input
                v-model="
                  settings.settings.otp_expiry
                "
                type="number"
                class="input-main"
                min="30"
              />
            </div>
            <div class="flex flex-col">
              <label class="text-sm mb-1"
                >{{ $t("resendDelay") }} ({{
                  $t("seconds")
                }})</label
              >
              <input
                v-model="
                  settings.settings.resend_delay
                "
                type="number"
                class="input-main"
                min="30"
              />
            </div>
          </div>
        </div>

        <div class="content mb-5">
          <h3 class="section-title">
            {{ $t("customFields") }}
          </h3>

          <button
            @click="addField"
            class="mb-4 bg-main text-white px-4 py-2 rounded-lg hover:opacity-90"
          >
            {{ $t("addNewField") }}
          </button>

          <div class="overflow-x-auto">
            <table
              class="min-w-full divide-y divide-gray-200"
            >
              <thead>
                <tr>
                  <th
                    class="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider"
                  >
                    {{ $t("fieldName") }}
                  </th>
                  <th
                    class="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider"
                  >
                    {{ $t("metaKey") }}
                  </th>
                  <th
                    class="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider"
                  >
                    {{ $t("fieldType") }}
                  </th>
                  <th
                    class="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider"
                  >
                    {{ $t("fieldStatus") }}
                  </th>
                  <th
                    class="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider"
                  >
                    {{ $t("options") }}
                  </th>
                  <th
                    class="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider"
                  >
                    {{ $t("actions") }}
                  </th>
                </tr>
              </thead>
              <tbody
                class="bg-white divide-y divide-gray-200"
              >
                <tr
                  v-for="(
                    field, index
                  ) in settings.settings
                    .custom_fields"
                  :key="index"
                >
                  <td class="px-6 py-4">
                    <input
                      v-model="field.name"
                      type="text"
                      class="input-main"
                      :placeholder="
                        $t('fieldNamePlaceholder')
                      "
                    />
                  </td>
                  <td class="px-6 py-4">
                    <input
                      v-model="field.meta_key"
                      type="text"
                      class="input-main"
                      :placeholder="
                        $t('metaKeyPlaceholder')
                      "
                      dir="ltr"
                    />
                  </td>
                  <td class="px-6 py-4">
                    <select
                      v-model="field.type"
                      class="input-main"
                    >
                      <option value="text">{{ $t("text") }}</option>
                      <option value="number">{{ $t("number") }}</option>
                      <option value="textarea">{{ $t("textarea") }}</option>
                      <option value="select">{{ $t("select") }}</option>
                      <option value="checkbox">{{ $t("checkbox") }}</option>
                      <option value="radio">{{ $t("radio") }}</option>
                      <option value="uploader">{{ $t("uploader") }}</option>
                    </select>
                  </td>
                  <td class="px-6 py-4">
                    <select
                      v-model="field.status"
                      class="input-main"
                    >
                      <option value="optional">
                        {{ $t("optional") }}
                      </option>
                      <option value="required">
                        {{ $t("required") }}
                      </option>
                    </select>
                  </td>
                  <td class="px-6 py-4">
                    <div v-if="['text', 'textarea', 'number'].includes(field.type)" class="mb-2">
                      <label class="text-xs block mb-1">{{ $t("characterLimit") }}</label>
                      <input
                        v-model="field.max_length"
                        type="number"
                        class="input-main"
                        min="1"
                      />
                    </div>
                    <div v-if="field.type === 'select' || field.type === 'radio'" class="mb-2">
                      <label class="text-xs block mb-1">{{ $t("options") }} ({{ $t("commaSeparated") }})</label>
                      <input
                        v-model="field.options"
                        type="text"
                        class="input-main"
                        :placeholder="$t('option1,option2')"
                      />
                    </div>
                    <div v-if="field.type === 'checkbox'" class="mb-2">
                      <label class="text-xs block mb-1">{{ $t("checkboxLabel") }}</label>
                      <input
                        v-model="field.checkbox_label"
                        type="text"
                        class="input-main"
                        :placeholder="$t('checkboxLabelPlaceholder')"
                      />
                    </div>
                    <div v-if="field.type === 'uploader'" class="mb-2">
                      <label class="text-xs block mb-1">{{ $t("acceptedFileTypes") }}</label>
                      <input
                        v-model="field.accepted_file_types"
                        type="text"
                        class="input-main"
                        :placeholder="$t('acceptedFileTypesPlaceholder')"
                        dir="ltr"
                      />
                    </div>
                  </td>
                  <td class="px-6 py-4">
                    <button
                      @click="removeField(index)"
                      class="text-red-600 hover:text-red-900"
                    >
                      {{ $t("remove") }}
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- استایل فرم ورود و مدال (پایین‌ترین بخش) -->
        <div class="content mb-5 mt-8">
          <h3 class="section-title mb-1">
            {{ $t("loginFormStyle") }}
          </h3>
          <div class="sub-text text-xs font-extralight text-[#696767] mb-4">
            {{ $t("loginFormStyleDescription") }}
          </div>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-5">
            <div class="flex flex-col">
              <label class="text-sm mb-1">{{ $t("modalButtonText") }}</label>
              <input
                v-model="loginStyle.modal_button_text"
                type="text"
                class="input-main"
                :placeholder="$t('login')"
              />
            </div>
            <div class="flex flex-col">
              <label class="text-sm mb-1">{{ $t("modalTriggerButton") }} – {{ $t("buttonBackgroundColor") }}</label>
              <div class="flex gap-2 items-center flex-wrap">
                <input
                  :value="loginStyle.modal_button_bg"
                  type="text"
                  class="input-main flex-1 min-w-0"
                  placeholder="#FFBF00"
                  dir="ltr"
                  @input="setColorValue('modal_button_bg', $event.target.value)"
                />
                <div class="smsir-color-swatch-wrap" @click="openPicker('modal_button_bg')">
                  <div class="smsir-color-swatch" :style="swatchStyle(loginStyle.modal_button_bg)" />
                </div>
              </div>
            </div>
            <div class="flex flex-col">
              <label class="text-sm mb-1">{{ $t("modalTriggerButton") }} – {{ $t("buttonTextColor") }}</label>
              <div class="flex gap-2 items-center flex-wrap">
                <input
                  :value="loginStyle.modal_button_text_color"
                  type="text"
                  class="input-main flex-1 min-w-0"
                  placeholder="#0D0D0D"
                  dir="ltr"
                  @input="setColorValue('modal_button_text_color', $event.target.value)"
                />
                <div class="smsir-color-swatch-wrap" @click="openPicker('modal_button_text_color')">
                  <div class="smsir-color-swatch" :style="swatchStyle(loginStyle.modal_button_text_color)" />
                </div>
              </div>
            </div>
            <div class="flex flex-col">
              <label class="text-sm mb-1">{{ $t("modalBackground") }} – {{ $t("backgroundColor") }}</label>
              <div class="flex gap-2 items-center">
                <input
                  :value="loginStyle.modal_background"
                  type="text"
                  class="input-main flex-1 min-w-0"
                  placeholder="#FFFFFF"
                  dir="ltr"
                  @input="setColorValue('modal_background', $event.target.value)"
                />
                <div class="smsir-color-swatch-wrap" @click="openPicker('modal_background')">
                  <div class="smsir-color-swatch" :style="swatchStyle(loginStyle.modal_background)" />
                </div>
              </div>
            </div>
            <div class="flex flex-col">
              <label class="text-sm mb-1">{{ $t("formBackground") }} – {{ $t("backgroundColor") }}</label>
              <div class="flex gap-2 items-center">
                <input
                  :value="loginStyle.form_background"
                  type="text"
                  class="input-main flex-1 min-w-0"
                  placeholder="#FFFFFF"
                  dir="ltr"
                  @input="setColorValue('form_background', $event.target.value)"
                />
                <div class="smsir-color-swatch-wrap" @click="openPicker('form_background')">
                  <div class="smsir-color-swatch" :style="swatchStyle(loginStyle.form_background)" />
                </div>
              </div>
            </div>
            <div class="flex flex-col">
              <label class="text-sm mb-1">{{ $t("formPrimaryButtons") }} – {{ $t("buttonBackgroundColor") }}</label>
              <div class="flex gap-2 items-center">
                <input
                  :value="loginStyle.primary_button_bg"
                  type="text"
                  class="input-main flex-1 min-w-0"
                  placeholder="#FFBF00"
                  dir="ltr"
                  @input="setColorValue('primary_button_bg', $event.target.value)"
                />
                <div class="smsir-color-swatch-wrap" @click="openPicker('primary_button_bg')">
                  <div class="smsir-color-swatch" :style="swatchStyle(loginStyle.primary_button_bg)" />
                </div>
              </div>
            </div>
            <div class="flex flex-col">
              <label class="text-sm mb-1">{{ $t("formPrimaryButtons") }} – {{ $t("buttonTextColor") }}</label>
              <div class="flex gap-2 items-center">
                <input
                  :value="loginStyle.primary_button_text_color"
                  type="text"
                  class="input-main flex-1 min-w-0"
                  placeholder="#0D0D0D"
                  dir="ltr"
                  @input="setColorValue('primary_button_text_color', $event.target.value)"
                />
                <div class="smsir-color-swatch-wrap" @click="openPicker('primary_button_text_color')">
                  <div class="smsir-color-swatch" :style="swatchStyle(loginStyle.primary_button_text_color)" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- پاپ‌اور انتخاب رنگ (Chrome Picker) -->
        <div
          v-if="activePickerField"
          class="smsir-color-picker-overlay"
          @click.self="activePickerField = null"
        >
          <div class="smsir-color-picker-popover">
            <ChromePicker
              :key="activePickerField"
              v-model="pickerModel"
              :disable-alpha="false"
              :formats="['hex', 'rgb', 'hsl']"
            />
          </div>
        </div>

      </div>
    </div>
    <div class="header-section mt-8">
      <div class="content-section mt-8">
        <div class="content mb-5">
          <h3 class="section-title">
            {{ $t("integration") }}
          </h3>

          <button
            @click="syncDigitsUsers"
            :disabled="syncing"
            class="bg-main text-white px-6 py-3 rounded-lg hover:opacity-90 flex items-center gap-2"
          >
            <span
              v-if="syncing"
              class="spinner-loading"
            ></span>
            <span
              >هماهنگ سازی اطلاعات کاربران قبلی با
              دیجیتس</span
            >
          </button>

          <div
            v-if="syncResult"
            class="mt-4 p-4 rounded-lg"
            :class="
              syncResult.success
                ? 'bg-green-100'
                : 'bg-red-100'
            "
          >
            {{ syncResult.message }}
          </div>

          <h3 class="section-title">
            {{ $t("wooCommerceSettings") }}
          </h3>
          <div class="content mb-5 flex gap-4">
          <label
            class="switch peer"
            for="change_checkout"
            ><input
              id="change_checkout"
              value="True"
              v-model="
                settings.settings.change_checkout
              "
              type="checkbox"
            />
            <div class="slider round"></div>
          </label>
          <div class="flex flex-col gap-1">
            <div class="text font-extralight">
              {{ $t("ChangeCheckoutLogin") }}
            </div>
          
          </div>
        </div>
          <div class="content mb-5 flex gap-4">
            <label
              class="switch peer"
              for="wc_email_optional"
              ><input
                id="wc_email_optional"
                value="True"
                v-model="
                  settings.settings
                    .wc_email_optional
                "
                type="checkbox"
              />
              <div class="slider round"></div>
            </label>
            <div class="flex flex-col gap-1">
              <div class="text font-extralight">
                {{
                  $t(
                    "makeEmailOptionalForPurchases"
                  )
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ChromePicker, tinycolor } from 'vue-color';
import 'vue-color/style.css';

export default {
  components: { ChromePicker },
  props: {
    settings: Object,
  },
  data() {
    return {
      syncing: false,
      syncResult: null,
      template_id: null,
      line_number: null,
      custom_fields: [],
      wc_email_optional: false,
      rate_limit_active: true,
      max_attempts: 5,
      ban_duration: 600,
      otp_expiry: 90,
      resend_delay: 90,
      mediaUploader: null,
      availableRoles: [],
      activePickerField: null,
    };
  },
  computed: {
    loginStyle() {
      return this.settings?.settings?.login_style ?? {};
    },
    currentPickerValue() {
      if (!this.activePickerField) return 'rgba(255,255,255,1)';
      const v = this.loginStyle[this.activePickerField];
      const normalized = this.normalizeColorValue(v);
      if (/^transparent$/i.test(normalized)) return 'rgba(0,0,0,0)';
      return normalized;
    },
    pickerModel: {
      get() {
        return this.currentPickerValue;
      },
      set(value) {
        if (!this.activePickerField) return;
        const str = this.colorToString(value);
        if (str != null) this.setColorValue(this.activePickerField, str);
      }
    }
  },
  methods: {
    colorToString(value) {
      if (value == null) return '';
      if (typeof value === 'string') return value.trim();
      const tc = tinycolor(value);
      if (!tc.isValid()) return '';
      const a = tc.getAlpha();
      return a >= 1 ? tc.toHexString() : tc.toRgbString();
    },
    isValidColorString(str) {
      if (!str || typeof str !== 'string') return false;
      const s = str.trim();
      if (/^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6}|[0-9A-Fa-f]{4}|[0-9A-Fa-f]{8})$/.test(s)) return true;
      if (/^rgba?\s*\([^)]+\)\s*$/.test(s)) return true;
      if (/^hsla?\s*\([^)]+\)\s*$/.test(s)) return true;
      if (/^transparent\s*$/i.test(s)) return true;
      return false;
    },
    normalizeColorValue(v) {
      if (!v || typeof v !== 'string') return 'rgba(255,255,255,1)';
      const s = v.trim();
      if (this.isValidColorString(s)) return s;
      return 'rgba(255,255,255,1)';
    },
    swatchStyle(value) {
      const color = this.normalizeColorValue(value);
      return { backgroundColor: color };
    },
    setColorValue(field, value) {
      const settings = this.settings?.settings;
      if (!settings) return;
      if (!settings.login_style) settings.login_style = {};
      const style = settings.login_style;
      if (value === '' || value == null) {
        style[field] = '';
        return;
      }
      style[field] = String(value).trim();
    },
    openPicker(field) {
      this.activePickerField = field;
    },
    openMediaUploader() {
      if (typeof wp.media !== "undefined") {
        let frame = wp.media({
          title: "Select or Upload Image",
          button: {
            text: "Use this image",
          },
          multiple: false,
        });

        frame.on("select", () => {
          let attachment = frame
            .state()
            .get("selection")
            .first()
            .toJSON();

            if (!this.settings.settings) {
              this.settings.settings = {};
            }
            
            this.settings.settings.custom_logo_id = attachment.id;
            this.settings.settings.custom_logo_url = attachment.url;
            
            this.settings = { ...this.settings };
         
        });
        frame.open();
      }
    },
 

    removeLogo() {
      this.settings.settings.custom_logo_id = '';
      this.settings.settings.custom_logo_url = '';
    },
    
    async fetchUserRoles() {
      try {
        const response = await fetch(window.sms_ir_login.ajaxUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: new URLSearchParams({
            action: 'smsir_get_user_roles',
            nonce: window.sms_ir_login.nonce,
          }),
        });

        const data = await response.json();

        if (data.success) {
          this.availableRoles = data.data.roles;
          
          // Set default role if not already set
          if (!this.settings.settings.default_user_role) {
            this.settings.settings.default_user_role = 'subscriber';
          }
        }
      } catch (error) {
        console.error('Error fetching user roles:', error);
      }
    },
    async syncDigitsUsers() {
      try {
        this.syncing = true;
        this.syncResult = null;

        const response = await fetch(
          window.sms_ir_login.ajaxUrl,
          {
            method: "POST",
            headers: {
              "Content-Type":
                "application/x-www-form-urlencoded",
            },
            body: new URLSearchParams({
              action: "smsir_sync_digits_users",
              nonce: window.sms_ir_login.nonce,
            }),
          }
        );

        const data = await response.json();

        this.syncResult = {
          success: data.success,
          message: data.data.message,
        };
      } catch (error) {
        this.syncResult = {
          success: false,
          message: "خطا در هماهنگ سازی اطلاعات",
        };
      } finally {
        this.syncing = false;
      }
    },
    addField() {
      if (!this.settings.settings.custom_fields) {
        this.settings.settings.custom_fields = [];
      }
      this.settings.settings.custom_fields.push({
        name: "",
        meta_key: "",
        status: "optional",
        type: "text",
        max_length: 100,
        options: "",
        checkbox_label: ""
      });
    },
    removeField(index) {
      this.settings.settings.custom_fields.splice(
        index,
        1
      );
    },
  },
  async created() {
    // Fetch available user roles when component is created
    await this.fetchUserRoles();
  },
  
  mounted() {
    // Don't initialize media uploader here, only when needed
    // This prevents errors when templates aren't loaded yet
  }
};
</script>

<style scoped>
/* ... existing styles */
.logo-preview {
  max-width: 200px;
  min-width: 100px;
  min-height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
  border-radius: 8px;
  padding: 8px;
  overflow: hidden;
}

.logo-preview img {
  max-width: 100%;
  max-height: 60px;
  object-fit: contain;
}

/* استایل فرم ورود – سواچ و پیکر رنگ */
.smsir-color-swatch-wrap {
  width: 40px;
  height: 40px;
  min-width: 40px;
  flex-shrink: 0;
  border-radius: 8px;
  border: 1px solid #D9D9D9;
  cursor: pointer;
  overflow: hidden;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8'%3E%3Cpath fill='%23e5e5e5' d='M0 0h4v4H0zm4 4h4v4H4z'/%3E%3Cpath fill='%23fff' d='M4 0h4v4H4zM0 4h4v4H0z'/%3E%3C/svg%3E");
  background-size: 8px 8px;
}
.smsir-color-swatch {
  width: 100%;
  height: 100%;
  border-radius: 7px;
}
.smsir-color-picker-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
.smsir-color-picker-popover {
  background: #fff;
  border-radius: 12px;
  padding: 0;
  box-shadow: 0 8px 32px rgba(0,0,0,0.2);
}
.smsir-color-picker-popover :deep(.vc-chrome) {
  border-radius: 12px;
  box-shadow: none;
}
</style>
